const mapChildIT = ({childITApplicationId, itApplicationName, itApplicationTypeId, knowledgeITApplicationId = null}) => ({
	id: childITApplicationId,
	name: itApplicationName,
	type: itApplicationTypeId,
	knowledgeITApplicationId
});

export default (response) => {
	const {childITApplications = [], ...data} = response?.data?.[0] ?? {};
	return {
		...data,
		childITApplications: childITApplications?.map(mapChildIT)
	};
};
